"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowNodeInstanceSortableColumns = exports.FlowNodeInstanceState = void 0;
var FlowNodeInstanceState;
(function (FlowNodeInstanceState) {
    FlowNodeInstanceState["running"] = "running";
    FlowNodeInstanceState["suspended"] = "suspended";
    FlowNodeInstanceState["finished"] = "finished";
    FlowNodeInstanceState["terminated"] = "terminated";
    FlowNodeInstanceState["error"] = "error";
    FlowNodeInstanceState["canceled"] = "canceled";
})(FlowNodeInstanceState = exports.FlowNodeInstanceState || (exports.FlowNodeInstanceState = {}));
var FlowNodeInstanceSortableColumns;
(function (FlowNodeInstanceSortableColumns) {
    FlowNodeInstanceSortableColumns["flowNodeInstanceId"] = "flowNodeInstanceId";
    FlowNodeInstanceSortableColumns["flowNodeId"] = "flowNodeId";
    FlowNodeInstanceSortableColumns["flowNodeName"] = "flowNodeName";
    FlowNodeInstanceSortableColumns["flowNodeLane"] = "flowNodeLane";
    FlowNodeInstanceSortableColumns["flowNodeType"] = "flowNodeType";
    FlowNodeInstanceSortableColumns["eventType"] = "eventType";
    FlowNodeInstanceSortableColumns["state"] = "state";
    FlowNodeInstanceSortableColumns["previousFlowNodeInstanceId"] = "previousFlowNodeInstanceId";
    FlowNodeInstanceSortableColumns["parentProcessInstanceId"] = "parentProcessInstanceId";
    FlowNodeInstanceSortableColumns["processDefinitionId"] = "processDefinitionId";
    FlowNodeInstanceSortableColumns["processModelId"] = "processModelId";
    FlowNodeInstanceSortableColumns["processInstanceId"] = "processInstanceId";
    FlowNodeInstanceSortableColumns["correlationId"] = "correlationId";
    FlowNodeInstanceSortableColumns["ownerId"] = "ownerId";
    FlowNodeInstanceSortableColumns["createdAt"] = "createdAt";
})(FlowNodeInstanceSortableColumns = exports.FlowNodeInstanceSortableColumns || (exports.FlowNodeInstanceSortableColumns = {}));
//# sourceMappingURL=FlowNodeInstance.js.map